module.exports = __webpack_public_path__ + "img/handmade-close-circle.522ecd12.svg";